/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_LoadingInputs */

const en_company_profile_loading = /** @type {(inputs: Company_Profile_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading company profile…`)
};

const de_company_profile_loading = /** @type {(inputs: Company_Profile_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil wird geladen…`)
};

/**
* | output |
* | --- |
* | "Loading company profile…" |
*
* @param {Company_Profile_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_loading = /** @type {((inputs?: Company_Profile_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_loading(inputs)
	return en_company_profile_loading(inputs)
});